import styled from 'styled-components';
import tw from 'twin.macro';
import BuyerSellerSectionComponent from '../../../components/dealer/agreement/buyerSellerSection';
import CarInfoSectionComponent from '../../../components/dealer/agreement/carInfoSection';
import FederalDisclosuresComponent from '../../../components/dealer/agreement/federalDisclosures';
import StatementOfInsuranceComponent from '../../../components/dealer/agreement/statementOfInsurance';
import ItemizationSection from '../../../components/dealer/agreement/itemizationSection';
import OptionalDebtSectionComponent from '../../../components/dealer/agreement/optionalDebtSection';
import OptionalServiceContractComponent from '../../../components/dealer/agreement/optionalServiceContract';
import TradeInVehicleSection from '../../../components/dealer/agreement/tradeInVehicleSection';
import ArbitrateSection from '../../../components/dealer/agreement/arbitrateSection';
import MutualAgreementSigns from '../../../components/dealer/agreement/mutualAgreementSigns';
import FinalSectionComponent from '../../../components/dealer/agreement/finalSection';
import SellerSignatureComponent from '../../../components/dealer/agreement/sellerSignatureComponent';
import OtherComponentPageOne from '../../../components/dealer/agreement/otherComponentPageOne';
import OtherComponentPageTwo from '../../../components/dealer/agreement/otherComponentPageTwo';
import OtherComponentPageThree from '../../../components/dealer/agreement/otherComponentPageThree';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import { useGetMyDealerQuery } from '../../../services/dealerService/__generated__/queries.generated';
import {
  IFindCarSaleQuery,
  useFindCarSaleLazyQuery,
} from '../../../services/carSaleServices/__generated__/queries.generated';
import { toast } from 'react-toastify';
import { useReactToPrint } from 'react-to-print';

const TableRow = styled.tr`
  ${tw``}
`;

const FormContainer = styled.div`
  ${tw`w-full max-w-5xl mx-auto p-8 bg-white min-w-[1030px]`}
`;

const Header = styled.div`
  ${tw`text-center font-bold text-xl mb-6`}
`;

const InfoBox = styled.div`
  ${tw`border border-gray-300 p-2 border border-gray-300 border-solid`}
`;

const Label = styled.span`
  ${tw`text-sm font-semibold mr-2`}
`;

const Text = styled.div`
  ${tw`text-sm mb-2`}
`;

const ContactRow = styled.div`
  ${tw`flex mb-2`}
`;

const TableSection = styled.div`
  ${tw`grid grid-cols-2 gap-4`}
  grid-template-columns: 56% 44%;
`;

const LeftTable = styled.div`
  ${tw`border border-gray-300`}
`;

const RightTable = styled.table`
  ${tw`border border-gray-300 w-full`}
`;

const BottomTable = styled.div`
  ${tw`border border-gray-300 border-solid`}
`;

const TableHeader = styled.th`
  ${tw`bg-gray-100 p-2 font-bold border-b border-gray-300`}
  text-align: left;
`;

const TableCell = styled.td`
  ${tw`p-2 border-r border-gray-300 last:border-r-0`}
`;

const PaymentSchedule = styled.div`
  ${tw`mt-6 border border-gray-300`}
`;

const WarningText = styled.div`
  ${tw`text-xs text-gray-600 p-0`}
`;

const PrintButton = styled.button`
  ${tw`bg-blue-500 text-white font-bold py-2 px-4 rounded mt-4`}
  @media print {
    display: none;
  }

  &:hover {
    ${tw`bg-blue-700`}
  }
`;

const PageHeader = styled.div`
  ${tw`flex justify-end mb-4 gap-4 items-center`}
  display: none;
  @media print {
    display: flex;
  }
`;

const SignatureBox = styled.div`
  ${tw`flex flex-col`}
`;

const SignatureLine = styled.div`
  ${tw`border-b border-black w-48 mt-1`}
`;

const SignatureLabel = styled.div`
  ${tw`text-xs text-gray-600 mt-1`}
`;

const PageContainer = styled.div`
  ${tw`relative w-full max-w-full min-w-0 box-border`}
  page-break-after: always;
  &:last-child {
    page-break-after: avoid;
  }
`;

const RetailInstallmentContract = () => {
  const mutualAgreementSigns = [
    {
      id: 1,
      title: 'Trade-In Payoff Agreement:',
      description:
        'Seller relied on information from you and/or the lienholder or lessor of your trade-in vehicles) to arrive at the payoff amount shown as the Prior Credit or Lease Balance in Trade-In Vehicle(s). You understand that the amount quoted is an estimate. Seller agrees to pay the payoff amount shown as the Prior Credit or Lease Balance in Trade-in Vehicle(s) to the lienholder or lessor of the trade-in vehicles), or its designe. It the actual payoff amount is more than the amount shown as the Prior Credit or Lease Balance in Trade-In Vehicles), you must pay the Seller the excess on demand. If the actual payoff amount is less than the amount shown as the Prior Credit or Lease Balance in Trade-In Vehicle(s), Seller will refund to you any overage Seller receives from your prior lienholder or lessor. Except as stated in the "NOTICE" on the back of this contract, any assigne of this contract wil not be obligated to pay the Prior Credit or Lease Balance shown in Trade-In Vehicle (s) or any refund. You agree to sign or provide any documents Seller reasonably requires to effect the transfer of the Trade-n Vehicle to Seller or its designee.',
    },
    {
      id: 2,
      titleInCenter: 'AUTO BROKER FEE DISCLOSURE',
      checkBoxContent: 'Name of autobroker reciving fee, if applicable:',
      description:
        'If this contract reflects the retail sale of a new motor vehicle, the sale is not subject to a fee received by an autobroker from us unless the following box is checked:',
    },
    {
      id: 3,
      title: 'HOW THIS CONTRACT CAN BE CHANGED:',
      description:
        'This contract contains the entire agreement between you and us relating to this contract. Any change to the contract must be in writing and both you and we must sign it. No oral changes are binding.',
    },
    {
      id: 4,
      title: "SELLER'S RIGHT TO CANCEL",
      description:
        "If Buyer and Co-Buyer sign here, the provisions of the Seller's Right to Cancel section on the back giving the Seller the right to cancel if Seller is unable to assign this contract to a financial institution will apply.",
    },
    {
      id: 5,
      signerTitle: 'S/S X',
      coSignerTitle: 'X',
      title: 'NOTICE',
      description:
        'THE MINIMUM PUBLIC LIABILITY INSURANCE LIMITS PROVIDED IN LAW MUST BE MET BY EVERY PERSON WHO PURCHASES A VEHICLE. IF YOU ARE UNSURE WHETHER OR NOT YOUR CURRENT INSURANCE POLICY WILL COVER YOUR NEWLY ACQUIRED VEHICLE IN THE EVENT OF AN ACCIDENT, YOU SHOULD CONTACT YOUR INSURANCE AGENT. WARNING: YOUR PRESENT POLICY MAY NOT COVER COLLISION DAMAGE OR MAY NOT PROVIDE FOR FULL REPLACEMENT COSTS FOR THE VEHICLE BEING PURCHASED. IF YOU DO NOT HAVE FULL COVERAGE, SUPPLEMENTAL COVERAGE FOR COLLISION DAMAGE MAY BE AVAILABLE TO YOU THROUGH YOUR INSURANCE AGENT OR THROUGH THE SELLING DEALER. HOWEVER, UNLESS OTHERWISE SPECIFIED, THE COVERAGE YOU OBTAIN THROUGH THE DEALER PROTECTS ONLY THE DEALER, USUALLY UP TO THE AMOUNT OF THE UNPAID BALANCE REMAINING AFTER THE VEHICLE HAS BEEN REPOSSESSED AND SOLD. FOR ADVICE ON FULL COVERAGE THAT WILL PROTECT YOU IN THE EVENT OF LOSS OR DAMAGE TO YOUR VEHICLE, YOU SHOULD CONTACT YOUR INSURANCE AGENT. THE BUYER SHALL SIGN TO ACKNOWLEDGE THAT HE/SHE UNDERSTANDS THESE PUBLIC LIABILITY TERMS AND',
    },
  ];
  const [searchParams] = useSearchParams();
  const agreementId = searchParams.get('agreementId');
  const [agreementIdState, setAgreementIdState] = useState(agreementId || '');
  const [agreementDataState, setAgreementDataState] = useState<IFindCarSaleQuery | undefined>(
    undefined,
  );

  const { data: dealerData } = useGetMyDealerQuery();

  const [getAgreementData, { data: agreementData }] = useFindCarSaleLazyQuery({
    fetchPolicy: 'cache-first',
    onCompleted: data => {
      setAgreementDataState(data);
    },
    onError: error => {
      toast.error(error.message);
    },
  });

  useEffect(() => {
    if (agreementIdState) {
      getAgreementData({ variables: { id: agreementIdState } });
    }
  }, [agreementIdState]);

  const contentRef = useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({
    contentRef: contentRef,
    pageStyle: `
      @page {
        margin: 1cm;
        size: letter;
        margin-header: 0;
        margin-footer: 0;
      }
         .custom-date {
          position: absolute;
          top: 10px;
          left: 10px;
          font-size: 12px;
          content: "11/23/2024";
        }
      @media print {
        .signature-header {
          display: flex;
          justify-content: flex-end;
          gap: 1rem;
          margin-bottom: 0rem;
        }
        body {
          -webkit-print-color-adjust: exact;
        }
        @page {
          size: auto;
          margin: 0;
        }
        @page :first {
          margin-top: 0;
        }
        @page :left {
          margin-left: 0;
        }
        @page :right {
          margin-right: 0;
        }
       .custom-date {
          position: absolute;
          top: 10px;
          left: 10px;
          font-size: 12px;
          content: "11/23/2024";
        }
      }
    `,
    documentTitle: 'Retail Installment Contract',
    onAfterPrint: () => {},
    onPrintError: (errorLocation, error) => {},
  });

  return (
    <>
      <FormContainer ref={contentRef}>
        <PageContainer>
          <Header>RETAIL INSTALLMENT SALE CONTRACT</Header>
          <BuyerSellerSectionComponent
            agreementId={agreementIdState}
            setAgreementIdState={setAgreementIdState}
            agreementData={agreementDataState}
          />
          <CarInfoSectionComponent
            agreementData={agreementDataState}
            agreementId={agreementIdState}
          />
          <TableSection>
            <LeftTable>
              <FederalDisclosuresComponent
                agreementId={agreementIdState}
                agreementData={agreementDataState}
              />
              <PageContainer>
                <ItemizationSection
                  agreementId={agreementIdState}
                  agreementData={agreementDataState}
                />
              </PageContainer>
            </LeftTable>

            <RightTable>
              <StatementOfInsuranceComponent />
              <OptionalDebtSectionComponent />
              <OptionalServiceContractComponent />
              <TradeInVehicleSection />
              <ArbitrateSection />
            </RightTable>
          </TableSection>

          <BottomTable>
            {mutualAgreementSigns.map(item => (
              <MutualAgreementSigns
                key={item.id}
                title={item.title}
                titleInCenter={item.titleInCenter}
                description={item.description}
                signerTitle={item.signerTitle}
                coSignerTitle={item.coSignerTitle}
                checkBoxContent={item.checkBoxContent}
              />
            ))}
            <FinalSectionComponent />
            <SellerSignatureComponent />
          </BottomTable>
          <FooterContainer>
            <FooterText>
              <CopyType>CUSTOMER/TRUTH IN LENDING COPY</CopyType>
            </FooterText>
          </FooterContainer>

          <OtherComponentPageOne />

          <OtherComponentPageTwo />

          <OtherComponentPageThree />
        </PageContainer>
      </FormContainer>
      <PrintButton onClick={() => handlePrint()}>Print Agreement</PrintButton>
    </>
  );
};

export default RetailInstallmentContract;
const FooterText = styled.div`
  ${tw`text-xs text-gray-600 flex items-center justify-between`}
`;

const CopyType = styled.span`
  ${tw`text-right font-semibold text-red-600`}
`;

const FooterContainer = styled.div``;
